import { Component,
	OnInit,
	ViewContainerRef
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Modal }                  from 'ngx-modialog/plugins/bootstrap';
import { environment }            from '../../environments/environment';
import { DataService }            from '../services/data.service';
import { SpinnerService }         from '../utilities/spinner/spinner.service';
import { PlayerModalService }     from '../modals/player-modal/player-modal.service';


/**
 * This class represents the lazy loaded WelcomeComponent.
 */
@Component({
	selector: 'app-welcome',
	templateUrl: './welcome.component.html',
	styleUrls: ['./welcome.component.css']
})
export class WelcomeComponent implements OnInit {
	pageHeight: number;
	isPageLoading: boolean;
	isVideoLink: boolean;

	backendApi: string;
	slugId: string;
	welcomeDescription: string;
	btnContent: string;
	logoUrl: string;
	videoLinkSrc: string;
	videoLink: string;
	callback: string;
	videoLinkText: string;

	constructor(
		private _dataService: DataService,
		private _spinner: SpinnerService,
		private _activatedRoute: ActivatedRoute,
		private _router: Router,
		private _playerModal: PlayerModalService,
		private _viewContainer: ViewContainerRef,
		private modal: Modal
	) {
		(modal.overlay as any).defaultViewContainer = _viewContainer;
		this.pageHeight = window.innerHeight;
		this.welcomeDescription = '';
		this.btnContent = '';
		this.logoUrl = '';
		this.callback = '';
		this.backendApi = environment['API'];
		this.isVideoLink = false;
	}

	ngOnInit() {
		this._activatedRoute.params.subscribe(params=> {
			this.slugId = params['slugId'];
			this.isPageLoading = false;
			this.getWelcomeData();
		});
	}

	getWelcomeData() {
		let postData = {
        	code: 200,
        	data: {
        		slug: this.slugId
        	}
        };

		this._spinner.start();
		this._dataService.post('v1/data/welcome', postData)
        	.subscribe((res: any) => {
        		let data = res.data;

        		if(data.forward) {
        			window.location.href = data.forward;
        		}

        		this.logoUrl       = this.backendApi + data.logo;
        		this.videoLinkSrc  = this.backendApi + data.video_link_src;
        		this.videoLinkText      = data.video_link_text;
        		this.welcomeDescription = data.desc;
        		this.btnContent         = data.next_btn;
        		this.callback           = data.callback;
        		this.videoLink          = data.video_link;

        		if(data.video === 0) {
        			this.isVideoLink = false;
        		} else {
        			this.isVideoLink = true;
        		}

        		this.isPageLoading = true;
        		this._spinner.stop();
        	}, (error: any) => console.error('Unable to fetch brands', error));
	}

	start() {
		let subUrl = '';
		if(this.callback === 'vin_photo') {
			subUrl = 'identify';
		} else {
			subUrl = '/' + this.callback;
		}
		this._router.navigate([subUrl, this.slugId]);
	}

	player() {
		this._playerModal.openDialog('', this._viewContainer);
	}
}




// WEBPACK FOOTER //
// /home/rubylover/Work/new_vin_photo/site/web/src/app/welcome/welcome.component.ts